import React from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";

type MobileClaimSuccessProps = {
  claimId: string;
  creditNumber: string;
  schemeName?: any;
  loadingClaim?: any;
};

const MobileClaimSuccess: React.FC<MobileClaimSuccessProps> = ({
  claimId,
  creditNumber,
  schemeName,
  loadingClaim,
}) => {
  const navigate = useNavigate();
  return (
    <div className="claim-success-card">
      {/* Badge */}
      <div className="badge">
        <div className="badge-inner">
          <svg
            width="34"
            height="26"
            viewBox="0 0 52 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="checkmark"
              d="M5 22L20 35L47 5"
              stroke="white"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>

      {/* Claim ID */}
      {loadingClaim && !claimId ? (
        <div className="info">
          <span className="label">Claim is getting generated</span>
          <div className="loader"></div>
        </div>
      ) : (
        <div className="info">
          <span className="label">
            {`${
              schemeName?.toLowerCase()?.includes("cghs")
                ? "Registration Id"
                : "Claim Id"
            } Generated Successfully`}
          </span>
          <span className="value">{claimId}</span>
        </div>
      )}
      {/* <div className="info">
        <span className="label">{`${schemeName?.toLowerCase()?.includes("cghs") ? "Registration Id" : "Claim Id"} Generated Successfully`}</span>
        <span className="value">{claimId}</span>
      </div> */}

      {/* Credit Number */}
      <div className="info">
        <span className="label">Credit Number</span>
        <span className="value">{creditNumber}</span>
      </div>

      {/* Action Button */}
      <div className="action">
        <button
          className="primary-btn"
          onClick={() => {
            navigate(ROUTES.ADD_PATIENT);
          }}
        >
          Create Another Patient
        </button>
      </div>

      {/* CSS */}
      <style>{`
        .claim-success-card {
          width: 100%;
          max-width: 320px;
          margin: 0 auto;
          padding: 20px 16px;
          background: #ffffff;
          border-radius: 14px;
          text-align: center;
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
        }

        .loader {
          margin: 10px auto;
          width: 22px;
          height: 22px;
          border: 3px solid #e5e7eb;
          border-top: 3px solid #0d4b87;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        .checkmark {
          stroke-dasharray: 100;
          stroke-dashoffset: 100;
          animation: draw 0.8s ease forwards;
        }

        @keyframes draw {
          to {
            stroke-dashoffset: 0;
          }
        }

        .badge-inner {
          animation: pop 0.4s ease-out;
        }

        @keyframes pop {
          0% {
            transform: scale(0.5);
          }
          70% {
            transform: scale(1.2);
          }
          100% {
            transform: scale(1);
          }
        }

        .badge {
          width: 72px;
          height: 72px;
          margin: 0 auto 14px;
          background: ;
          clip-path: polygon(
            50% 0%,
            62% 8%,
            75% 5%,
            85% 15%,
            95% 25%,
            92% 38%,
            100% 50%,
            92% 62%,
            95% 75%,
            85% 85%,
            75% 95%,
            62% 92%,
            50% 100%,
            38% 92%,
            25% 95%,
            15% 85%,
            5% 75%,
            8% 62%,
            0% 50%,
            8% 38%,
            5% 25%,
            15% 15%,
            25% 5%,
            38% 8%
          );
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .badge-inner {
          width: 52px;
          height: 52px;
          background: #0d4b87;
          border: 4px solid #ffffff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .info {
          margin-top: 10px;
        }

        .action {
          margin-top: 18px;
        }

        .primary-btn {
          width: 100%;
          padding: 10px 14px;
          font-size: 14px;
          font-weight: 600;
          color: #ffffff;
          background: #0d4b87;
          border: none;
          border-radius: 8px;
          transition: background 0.2s ease, transform 0.1s ease;
        }

        .primary-btn:active {
          transform: scale(0.98);
        }

        .label {
          display: block;
          font-size: 12px;
          color: #6b7280;
          margin-bottom: 2px;
        }

        .value {
          font-size: 15px;
          font-weight: 600;
          color: #111827;
          word-break: break-word;
        }
      `}</style>
    </div>
  );
};

export default MobileClaimSuccess;
